import React from 'react';

const SEOContent = ({ darkMode, children, title }) => {
  return (
    <div className={`${darkMode ? 'bg-slate-800 border-slate-700' : 'bg-white border-slate-100'} rounded-xl border shadow-lg p-6 mt-8`}>
      {title && (
        <h2 className={`text-xl font-bold mb-4 ${darkMode ? 'text-white' : 'text-slate-800'}`}>
          {title}
        </h2>
      )}
      <div className={`prose max-w-none ${darkMode ? 'prose-invert' : ''}`}>
        <div className={`${darkMode ? 'text-slate-300' : 'text-slate-600'} leading-relaxed space-y-4`}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default SEOContent;
